import { Route, Routes } from 'react-router-dom';
import { OrganizationsPage } from './OrganizationsPage';

export const OrganizationsRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<OrganizationsPage />} />
    </Routes>
  );
};
